import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthToken } from "../utils/auth";

type Props = {
  children: React.ReactElement;
};

export default function ProtectedRoute({ children }: Props) {
  const token = getAuthToken();
  if (!token) {
    return <Navigate to="/unauthenticated" replace />;
  }
  return children;
}
